<template>
    <mini-calculator-page>
        <div slot="summary-panel">
            <div class="p-animated-calc__results a-form-inputs u-full-width u-margin-auto">
                <mini-calculator-header title="Gross/Net Pension Calculator" icon="pension"/>

                <control label="Fiscal Year">
                    <select ref="fiscalYear" v-model="fiscalYear">
                        <option>2019/20</option>
                        <option>2018/19</option>
                        <option>2017/18</option>
                        <option>2016/17</option>
                        <option>2015/16</option>
                        <option>2014/15</option>
                        <option>2013/14</option>
                        <option>2012/13</option>
                        <option>2011/12</option>
                        <option>2010/11</option>
                    </select>
                </control>

                <control label="Net or Gross">
                    <select ref="pensionType" v-model="pensionType">
                        <option>Gross</option>
                        <option>Net</option>
                    </select>
                </control>

                <control label="Pension Income" before-after="pound">
                    <input autocomplete="off"
                           v-model.number="income"
                           ref="income"
                           type="number"
                           v-on:focus="income = income || ''"
                           v-on:blur="income = income || 0"
                           v-two-dp
                    >
                </control>

                <div>
                    <h2>
                        Result
                    </h2>

                    <control label="Gross Income" before-after="pound-on-dark">
                        <input autocomplete="off" type="text" disabled v-model.number="pension.results.grossIncome">
                    </control>

                    <control label="Net Income" before-after="pound-on-dark">
                        <input autocomplete="off" type="text" disabled v-model.number="pension.results.netIncome">
                    </control>

                    <control label="Income Tax Paid" before-after="pound-on-dark">
                        <input autocomplete="off" type="text" disabled v-model.number="pension.results.taxPaid">
                    </control>
                </div>

            </div>
        </div>

        <div slot="results-panel" v-show="showResults">
            <div class="p-animated-calc__results-panel u-full-width u-margin-auto">
                <h2>
                    Explanation
                </h2>

                <p>
                    With a gross pension income of £{{twoDp(pension.results.grossIncome || 0)}}, for the fiscal year of {{ fiscalYear
                    }},
                    £{{twoDp(pension.results.taxPaid || 0)}} of income tax would be paid. The breakdown for this calculation is outlined 
                    further down this page, noting the personal allowance and tax brackets for the fiscal year selected.
                </p>

                <p>
                    This results in a Net pension income of £{{twoDp(pension.results.netIncome || 0)}}
                </p>

                <p>
                    The following chart provides a visual indication of income tax paid on the gross pension:<br>
                </p>

                <div v-if="pension.results.grossIncome" class="chart">
                    <pie-chart :chart-data="chartData" :options="chartOptions"></pie-chart>
                </div>

                <!-- to be updated when copy received -->
                <!-- <h2>
                    Calculation
                </h2>

                <p>
                    [ Insert explanation here of how income tax was calculated — each income tax brackets allowance for the fiscal year etc. ]
                </p> -->
            </div>
        </div>
    </mini-calculator-page>
</template>

<script type="text/babel">
    import Vue from 'vue';
    import MiniCalculatorPage from 'pages/mini-calculators/components/MiniCalculatorPage';
    import miniCalcIcons from 'components/Icons';
    import Control from 'components/form/Control';
    import Intro from 'pages/mini-calculators/calculators/CalculatorComponents/Intro';
    import PieChart from 'components/graphs/PieChart.js';
    import CalculatorKeyBindings from 'pages/mini-calculators/calculators/mixins/MiniCalculatorBindings';
    import MiniCalculatorHeader from 'pages/mini-calculators/components/MiniCalculatorHeader';
    import {mapGetters, mapActions} from 'vuex';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'pension',
        data: function () {
            return {
                chartData: {},
                chartOptions: {},
                showResults: false
            }
        },
        created() {
            this.resetForm();
        },
        mixins: [
            CalculatorKeyBindings
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        props: {},
        computed: {
            /**
             * Allows access to Pension State.
             */
            ...mapGetters('mini/pension', {pension: 'all', total: 'total'}),
            income: {
                get() {
                    return this.pension.income
                },
                set(value) {
                    this.setPension({key: 'income', value});
                },
            },
            pensionType: {
                get() {
                    return this.pension.pensionType
                },
                set(value) {
                    this.setPension({key: 'pensionType', value});
                },
            },
            fiscalYear: {
                get() {
                    return this.pension.fiscalYear
                },
                set(value) {
                    this.setPension({key: 'fiscalYear', value});
                },
            },
        },
        watch: {
            ['pension.results']() {
                this.updateChart();
            }
        },
        methods: {
            /**
             * Allows setting on the Pension State
             */
            ...mapActions('mini/pension', {setPension: 'set', resetForm: 'reset'}),
            twoDp(value) {
                return (Math.round(value * 100) / 100).toFixed(2);
            },
            updateChart() {
                this.hidePrompt();
                this.showResults = true;

                let netIncome = this.pension.results.netIncome;
                let taxPaid = this.pension.results.taxPaid;

                this.chartData = {
                    labels: ['Net Income', 'Income Tax Paid'],
                    datasets: [
                        {
                            label: 'Gross Income Breakdown',
                            backgroundColor: [
                                '#4A89E5',
                                '#c5ecfe',
                            ],
                            data: [netIncome, taxPaid],
                        }
                    ]
                };
            },
        },
        components: {
            Control,
            MiniCalculatorPage,
            MiniCalculatorHeader,
            miniCalcIcons,
            Intro,
            PieChart,
        },
    }
</script>



// WEBPACK FOOTER //
// pension.vue?1ef292da